// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J8dy","right":"styles_right__2aGqU"};